module.exports = __webpack_public_path__ + "img/NFfavicon.5dc713b9.png";